import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { AlertCircle } from "@digital-twins/design-system/icons";
import { Text } from "@/components/ui/Text";
import { ROUTES } from "@/routes/routes";
import type { CreativeUsageWarningLevel } from "./creativeUsage";

export interface CreativeUsageWarningProps {
  name: string;
  usage: CreativeUsageWarningLevel;
  /** Set only when the viewer can change this material's Allowed use. */
  allowedUseToken?: string | null;
  testId: string;
}

/** One line on external work using unapproved material. It informs and never stops the work. */
export function CreativeUsageWarning(props: CreativeUsageWarningProps) {
  const { name, usage, allowedUseToken, testId } = props;

  const { t } = useTranslation("app");

  return (
    <div
      role="status"
      className="flex min-w-0 items-start gap-2 text-muted-foreground"
      data-testid={testId}
    >
      <AlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
      <Text size="xs" color="muted" className="min-w-0 break-words">
        {t(`creativeLibrary.usageWarning.${usage}`, { name })}
        {allowedUseToken ? (
          <>
            {" "}
            <Link
              to={`${ROUTES.knowledge}?view=creatives&creative=${encodeURIComponent(allowedUseToken)}`}
              target="_blank"
              rel="noreferrer"
              className="underline underline-offset-2 hover:text-foreground"
              data-testid={`${testId}-allowed-use`}
            >
              {t("creativeLibrary.allowedUsage")}
            </Link>
          </>
        ) : null}
      </Text>
    </div>
  );
}
